module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/28c965203a7be819e7a2d06a75cd3c15.png";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/past_certificates/gold.png
// module id = Ho0q
// module chunks = 0